var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import channel from '../../socket';
import { showFlash } from '../flash_show';
const SOCKET_EVENTS = Object.freeze({
    SPOTIFY_SHOW_INGESTED: 'spotify_show_ingested'
});
const onPodcastSettingsPage = (distributionId) => {
    return !!document.querySelector(`.js-backend_publication_podcast_settings_${distributionId}`);
};
const onSpotifyShowIngested = (_a) => __awaiter(void 0, [_a], void 0, function* ({ distributionId }) {
    if (onPodcastSettingsPage(distributionId)) {
        const notice = document.querySelector('.js-waiting_for_spotify_ingestion_notice');
        const message = notice === null || notice === void 0 ? void 0 : notice.dataset.onIngestionCompleteMessage;
        if (message) {
            yield window.up.reload('.unpoly_wrapper', { scroll: false });
            showFlash('success', message);
        }
    }
});
if (channel) {
    const channelHandler = channel.on(SOCKET_EVENTS.SPOTIFY_SHOW_INGESTED, onSpotifyShowIngested);
    window.addEventListener('beforeunload', () => {
        channel === null || channel === void 0 ? void 0 : channel.off(SOCKET_EVENTS.SPOTIFY_SHOW_INGESTED, channelHandler);
    });
}
